import { render, staticRenderFns } from "./mOrderListFail.vue?vue&type=template&id=3d467872&"
import script from "./mOrderListFail.vue?vue&type=script&lang=js&"
export * from "./mOrderListFail.vue?vue&type=script&lang=js&"
import style0 from "./mOrderListFail.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports